window.okeReviewsWidgetOnInit = function () {
    const reviewsWidgets = document.querySelectorAll('[data-oke-reviews-widget]');

    for (const reviewsWidget of reviewsWidgets) {
        const reviewMainElement = reviewsWidget.querySelector('.js-okeReviews-reviews-main');
        if (reviewMainElement) {
            const observer = new MutationObserver(() => {
                moveReviewerToReviewMeta(reviewMainElement);
                moveReviewerRecommendation(reviewMainElement);
            });
            observer.observe(reviewMainElement, {
                childList: true
            });
            moveReviewerRecommendation(reviewMainElement);
            moveReviewerToReviewMeta(reviewMainElement);
            setupHeader(reviewsWidget);
        }
    }

	duplicateWarButton();
};

function duplicateWarButton() {
    const warButton = document.querySelector('.js-okeReviews-writeReview');
    const productDetailStarRating = document.querySelector('.c-product-details .js-okeReviews-reviewsSummary');
    if (warButton && warButton.href && productDetailStarRating) {
        const warButtonClone = warButton.cloneNode(true);
        productDetailStarRating.insertAdjacentElement('beforeend', warButtonClone);
    }
}

function setupHeader(reviewsWidget) {
    const reviewWidgetHeaderControl = reviewsWidget.querySelector('.okeReviews-reviewsWidget-header-controls');
    const ratingSummary = reviewsWidget.querySelector('.okeReviews-reviewsAggregate-summary');
    if (reviewWidgetHeaderControl && ratingSummary) {
        reviewWidgetHeaderControl.insertAdjacentElement('afterbegin', ratingSummary);
        const reviewCount = ratingSummary.querySelector('.okeReviews-reviewsAggregate-summary-total');
        reviewCount.innerHTML = reviewCount.innerHTML.replace('Based on ', '');
    }

    const starRatingBreakdownLabels = reviewsWidget.querySelectorAll('.okeReviews-ratingDistribution-item-label-inner');
    for (const starRatingBreakdownLabel of starRatingBreakdownLabels) {
        starRatingBreakdownLabel.innerText = starRatingBreakdownLabel.innerText.replace(/\D/g, '');
    }
}

function moveReviewerToReviewMeta(reviewMainElement) {
    const reviews = reviewMainElement.querySelectorAll('.okeReviews-reviews-review');
    for (const review of reviews) {
        const reviewerName = review.querySelector('.okeReviews-review-side .okeReviews-review-reviewer-profile-details-inner');
        const reviewMeta = review.querySelector('.okeReviews-review-primary .okeReviews-review-starRating');

        if (reviewerName && reviewMeta) {
            reviewMeta.insertAdjacentElement('afterend', reviewerName);
        }
    }
}

function moveReviewerRecommendation(reviewMainElement) {
    let recommendRatings = reviewMainElement.querySelectorAll('.okeReviews-review-recommendation');
    let reviewBodies = reviewMainElement.querySelectorAll('.okeReviews-review-primary');
    if (recommendRatings.length > 0 && reviewBodies.length > 0) {
        for (let i = 0; i < recommendRatings.length; i++) {
            reviewBodies[i].insertAdjacentElement('beforeend', recommendRatings[i]);
        }
    }
}
